import {CodeMasterInterface} from '../CodeMaster'
import {Nullable} from '../app/TypeHelpers'

const EMPTY_STRING = ''

export function valueStringOrNull(target: Nullable<CodeMasterInterface>): Nullable<string> {
    return target ? target.value : null
}

export function valueStringOrEmpty(target: Nullable<CodeMasterInterface>): string {
    return valueStringOrNull(target) || EMPTY_STRING
}
